module.exports = __webpack_public_path__ + "img/solution_institutionalcare_sys.601acfb2.jpg";